/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, themeStyleHelper, classStyleHelper } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// GROUP
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	group: {

		// ----- variants ----- //
		'&.variant-raised': {
			// background: theme.color.light.light.swatch,
			boxShadow: theme.boxShadow.small,
			borderRadius: pxToEm(5)
		},
		'&.variant-outline': {
			borderRadius: pxToEm(5),
			border: replacePXinStringWithEM(`1px solid ${theme.color.neutral.medium.swatch}`)
		},

		// ----- types ----- //
		'&.type-fields': {
			'& .field': {
				marginRight: pxToEm(40),
				'&:last-child': {
					marginRight: '0'
				}
			}
		},
		'&.type-radiobuttons': {
			'& .field': {
				'& .label': {
					color: `rgba(6, 43, 117, 0.5)`
				}
			}
		},

		// ----- colors ----- //
		// generates classes for every color in the theme ".color-(uniqueColor)"
		extend: [classStyleHelper.direction, classStyleHelper.align, themeStyleHelper(theme, 'color', (theme, uniqueColor) => {
			return {
				background: theme.color[uniqueColor].medium.swatch,
				color: theme.color[uniqueColor].medium.contrast
			}
		})]
	}
});